export const knowledgeMarket = [
    {
        value: 1,
        label: 'Nulo'
    },
    {
        value: 1,
        label: 'Básico'
    },
    {
        value: 3,
        label: 'Intermedio'
    },
    {
        value: 4,
        label: 'Avanzado'
    }
]

export const objectiveInvestment = [
    {
        value: 1,
        label: 'Creciemiento de capital'
    },
    {
        value: 2,
        label: 'Protección de patrimonio'
    },
    {
        value: 3,
        label: 'Ingreso pasivo'
    },
    {
        value: 2,
        label: 'Otro'
    }
]

export const investmentFinancial = [
    {
        value: 1,
        label: 'Nunca'
    },
    {
        value: 1,
        label: 'Entre 1 y 5 años'
    },
    {
        value: 2,
        label: 'Menos de un año'
    },
    {
        value: 3,
        label: 'Más de 5 años'
    }
]

export const retirementDate = [
    {
        value: 1,
        label: '< a 1 año'
    },
    {
        value: 1,
        label: 'Entre 3 - 5 años'
    },
    {
        value: 2,
        label: 'Entre 1 - 3 años'
    },
    {
        value: 3,
        label: '5 años'
    }
]

export const retirementAction = [
    {
        value: 3,
        label: 'Mantener'
    },
    {
        value: 1,
        label: 'Vender'
    },
    {
        value: 1,
        label: 'Reducir exposición'
    },
    {
        value: 2,
        label: 'No lo sé'
    }
]

export const returnVariation = [
    {
        value: 1,
        label: 'Prefiero seguridad sin pérdidas'
    },
    {
        value: 2,
        label: 'Acepto cierta volatilidad a cambio de mejor rentabilidad'
    },
    {
        value: 3,
        label: 'Estoy dispuesto a asumir alta volatilidad por mayor rentabilidad'
    }
]

export const percentageSavings = [
    {
        value: 1,
        label: '< a 25%'
    },
    {
        value: 2,
        label: '> a 50%'
    },
    {
        value: 3,
        label: 'Entre 25% - 50%'
    }
]

export const resultManagement = [
    {
        label: 'Conservador',
        description: 'Busca protección máxima, no tolera pérdidas',
        range: [7,8,9],
        percentages: [15,55,20,10,0,0,0]
    },
    {
        label: 'Conservador moderado',
        description: 'Tolerancia limitada al riesgo, prefiere estabilidad',
        range: [10,11,12],
        percentages: [10,40,10,15,5,15,5]
    },
    {
        label: 'Moderado',
        description: 'Busca equilibrio entre crecimiento y seguridad',
        range: [13,14,15],
        percentages: [5,25,15,15,10,20,10]
    },
    {
        label: 'Agresivo moderado',
        description: 'Acepta volatilidad por mayor rentabilidad',
        range: [16,17,18],
        percentages: [2,15,10,10,20,25,18]
    },
    {
        label: 'Agresivo',
        description: 'Está dispuesto a asumir grandes riesgos por crecimiento a largo plazo',
        range: [19,20,21],
        percentages: [1,4,10,5,25,30,25]
    }
]